import React from "react";
import Item from "./Item";
import { motion } from "framer-motion";
import { container } from "../../utils/animationUtils";

function Menu({ menus, onClickItem }) {
  function renderDivider(index) {
    return <hr key={index} className="dropdown-divider bg-light" />;
  }

  return (
    <motion.ul
      variants={container()}
      initial="hidden"
      animate="show"
      className="navbar-nav w-100 d-flex flex-column gap-1"
    >
      {menus.map((menu, i) => {
        if (!Object.keys(menu).length) return renderDivider(i);
        const key = menu.key || menu.route || "menu-" + i;
        return <Item key={key} menu={menu} onClick={onClickItem} />;
      })}
    </motion.ul>
  );
}

export default Menu;
